export const carouselValidation = (carouselContent) => {
    if (carouselContent === null) {
        return false;
    }
    const validCards = carouselContent.filter(
        (mc) =>
            mc.title &&
            mc.text &&
            mc.backgroundColor &&
            mc.carouselImage &&
            mc.carouselImage.url &&
            mc.carouselDesktopImage &&
            mc.carouselDesktopImage.url &&
            mc.carouselTabletImage &&
            mc.carouselTabletImage.url &&
            mc.carouselMobileImage &&
            mc.carouselMobileImage.url &&
            mc.backgroundType &&
            mc.cta &&
            mc.cta.label &&
            mc.cta.internal &&
            mc.cta.url,
    );
    if (validCards.length >= 1) {
        return true;
    }
    return false;
};
